import { render, staticRenderFns } from "./uiPdf.vue?vue&type=template&id=98370650"
import script from "./uiPdf.vue?vue&type=script&lang=js"
export * from "./uiPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports